export default "__VITE_ASSET__DxDAiOG1__"